import { KampaayDataProvider } from 'services/api/dataProvider'
import { PhysicalExperience } from 'services/api/entities/catalog/physical/types/internal/physical-models'
import { EntityDescriptor } from '.'
import { formatExperience } from './common'

const formatPhysicalExperience =
  (dp?: KampaayDataProvider) =>
  ({ fullAddress, ...rest }: PhysicalExperience) => ({
    ...formatExperience(dp)(rest),
    address: fullAddress,
  })

export const physicals: EntityDescriptor<PhysicalExperience> = {
  format: formatPhysicalExperience,
}
